import React from 'react';
import HomeLeftBar from '@common_components/layout/LeftBarManager';
import Footer from '@common_components/global/footer.component';
import HomeTopBar from '@common_components/global/homeTopBar.component';


interface PageProps {
  children: JSX.Element;
  title: string;
}

const Page: React.FC<PageProps> = ( { children, title } ) => {
  return (
    <div className='flex min-h-screen w-screen bg-white-base text-black overflow-x-hidden'>
      <div className='w-fit flex-shrink-0'>
        <HomeLeftBar variant='basic'/>
      </div>
      <div className='flex flex-col flex-1 min-w-0 px-10'>
        <HomeTopBar>
          <span className="font-comfortaa text-5xl">{title}</span>
        </HomeTopBar>
        { children }
      </div>
      <Footer />
    </div>
  );
};

export default Page;
